<script>
    import { createEventDispatcher } from 'svelte';

    const dispatcher = createEventDispatcher();
    let buyInPanel;
    let buyInInput;
    let autoReBuy;
    let autoTopOff;
    export let minBuyIn;
    export let maxBuyIn;

    export function show()
    {
        buyInPanel.style.display = "block";
    }

    function onBuyIn()
    {
        buyInPanel.style.display = "none";
        dispatcher('buyIn', {buyInAmount: parseInt(buyInInput.value), autoReBuy: autoReBuy.checked, autoTopOff: autoTopOff.checked});
    }

    function onCancel()
    {
        buyInPanel.style.display = "none";
        dispatcher('buyInCancelled');
    }

</script>

<ion-card class="panel" bind:this={buyInPanel} style="display: none;">
    <ion-card-header style="text-align: center;">
      <ion-card-title>Buy-in amount</ion-card-title>
    </ion-card-header>
  
    <ion-card-content style="text-align: center;">
        <ion-item>
            <ion-input bind:this={buyInInput} style="text-align: center;" type="number" min="{minBuyIn}" max="{maxBuyIn}" value="{minBuyIn}" step="10"></ion-input>
        </ion-item>
        <div class="hbox center" style="padding-top: 20px;">
            <ion-checkbox bind:this={autoReBuy} slot="start" style="margin-right: 5px;"></ion-checkbox>
            <ion-label> Auto Re-Buy</ion-label>
            <span style="width: 20px;"> </span>
            <ion-checkbox bind:this={autoTopOff} slot="start" style="margin-right: 5px;"></ion-checkbox>
            <ion-label> Auto Top-Off</ion-label>
        </div>
        <div class="hbox center" style="padding-top: 15px;">
            <ion-button on:click={onBuyIn}>Ok</ion-button>
            <ion-button on:click={onCancel}>Cancel</ion-button>
        </div>
    </ion-card-content>
</ion-card>

<style>
    .panel {
        position: absolute;
        width: 280px;
        height: 220px;
        left: 260px;
        top: 190px;
    }
</style>